module.exports = __webpack_public_path__ + "media/images/spree/frontend/credit_cards/icons/visaelectron-e0e7599a99bced2b50fc093fd9b2d762.png";